"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafelyQuicklySign = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsPingAnRegister_1 = require("../../model/hsPingAnRegister");
var service_1 = require("../../../library/base/service");
var SafelyQuicklySign = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SafelyQuicklySign, _super);
    function SafelyQuicklySign() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '平安银商结算通快捷注册签约';
        _this.code = '105022';
        _this.desc = '平安银商结算通快捷注册签约';
        _this.requestParams = new hsPingAnRegister_1.SafelyQuicklySignRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SafelyQuicklySign;
}(service_1.BaseService));
exports.SafelyQuicklySign = SafelyQuicklySign;
//# sourceMappingURL=safelyQuicklySign.js.map